var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.86,
    height: 13.667,
    viewBox: "0 0 13.86 13.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.776,11.981H13.46a1.776,1.776,0,0,0-1.774,1.774v5.876A1.772,1.772,0,0,0,13.46,21.4h5.9a.509.509,0,0,1,.354.149l2.933,4.012c.163.158.433.093.433-.135V21.763c0-.279.177-.368.456-.368h.047a1.938,1.938,0,0,0,1.96-1.769V13.755A1.766,1.766,0,0,0,23.776,11.981Z",
    transform: "translate(-11.686 -11.981)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.7c4f5a80f68c81b2adaa484cd8e94409.svg";
export { ForwardRef as ReactComponent };